import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycUnionSquareOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'union-square',
  neighborhoodDisplayName: 'Union Square',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 5,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark:
    'from the buildings along W 17th St, th Ave, and 14th St to the clusters near Union Square Park',
  whereTeamStreets: 'W 17th St, th Ave, 14th St, Broadway',
  clientDescriptor: 'a small team tech startup near W 17th St',
  counts: {
    managedCleaningOffices: 4,
    managedPantryOffices: 5,
    managedInternetOffices: 5,
    managedFurnitureOffices: 4,
    managedOfficeAssistantOffices: 4,
    managedDeepCleaningOffices: 3,
    managedCarpetCleaningOffices: 2,
    managedWindowCleaningOffices: 2,
    managedGlassCleaningOffices: 3,
    managedWasteRecyclingOffices: 2,
    managedPantryInventoryOffices: 4,
    managedCoffeeServiceOffices: 4,
    managedWaterServiceOffices: 3,
    managedTeamLunchOffices: 2,
    managedBreakfastCateringOffices: 2,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 2,
    managedHappyHourOffices: 2,
    managedConferenceRoomAvOffices: 3,
    managedNetworkInstallationOffices: 4,
    managedNetworkManagementOffices: 3,
    managedCableManagementOffices: 2,
    managedRoomBookingOffices: 2,
    managedPrintingSetupOffices: 3,
    managedInteriorDesignOffices: 3,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 2,
    managedGlassFrostingOffices: 2,
    managedOfficeSignageOffices: 2,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 4,
    managedLayoutChangeOffices: 2,
    managedOfficePlantsOffices: 3,
    managedKeylessAccessOffices: 4,
    managedAlarmSystemsOffices: 2,
    managedSecurityCamerasOffices: 3,
    managedKeypadOffices: 2,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 2,
    managedBusinessInsuranceOffices: 3,
    managedElectricalServicesOffices: 3,
    managedHvacOffices: 3,
    managedPlumbingOffices: 2,
    managedPestControlOffices: 2,
    managedOfficeMovingOffices: 3,
    managedMountingInstallationOffices: 5
  },
  quotes: {
    cleaning: 'The Codi team has been very responsive whenever a maintenance issue comes up.',
    pantryRestocking: "The pantry was always a pain. Now it's just stocked every week.",
    internet: 'COI requirements for riser access are a headache. Codi just handles it.',
    officeAssistant: 'We needed someone on site who knows the building and the vendors.',
    officeFurniture: 'Elevator booking for furniture deliveries is a whole thing in NYC. Codi handled it.',
    deepCleaning: 'Union Square foot traffic means deep cleans are essential. Codi runs the schedule.',
    carpetCleaning: 'High traffic office near Union Square, carpet needs professional attention. Codi handles it.',
    windowCleaning: 'Street-level windows in Union Square get dirty fast. Codi keeps them clean.',
    glassConferenceRoom: 'Our glass conference walls are always in view of the team. Codi keeps them spotless.',
    wasteRecycling: 'NYC waste compliance matters. Codi manages our scheduled pickup without any effort from us.',
    pantryInventory:
      'Union Square startup \u2014 team snacks are not optional. Codi tracks inventory and reorders automatically.',
    coffeeService: 'Good coffee is a recruitment tool at this point. Codi manages the machine and keeps beans stocked.',
    waterService: 'Filtered water in our Union Square office. Codi set it up and maintains it on a regular schedule.',
    teamLunch: 'Weekly team lunch near the park. Codi handles caterer coordination and building delivery access.',
    breakfastCatering: 'Tuesday breakfast before product reviews. Codi handles it every week without a reminder.',
    individualMeals: 'Daily lunch for the Union Square team. Codi manages the vendor and delivery logistics.',
    adHocCatering: 'All-hands, investor visits, offsites \u2014 Codi handles catering for every Union Square event.',
    happyHour: 'Friday happy hour in our Union Square office. Codi handles drinks and setup every week.',
    conferenceRoomAv:
      'Three conference rooms in our Union Square office. Codi installed A/V in all of them in one visit.',
    networkInstallation:
      'Union Square startup, new office build-out. Codi handled the full network install and ISP provisioning.',
    networkManagement:
      'Codi manages our Union Square network. Fast troubleshooting, proactive monitoring, zero surprise outages.',
    cableManagement:
      'Open office layout meant visible cables everywhere. Codi organized and ran clean cable management throughout.',
    roomBooking:
      'Union Square office with constant meeting room contention. Codi deployed tablets and the conflict rate dropped to zero.',
    printingSetup:
      'Printer rollout for a Union Square floor. Codi coordinated delivery and configured every workstation.',
    interiorDesign:
      'Union Square office refresh before a team doubling. Codi handled the space plan and the full fit-out.',
    officeMurals:
      'Tech startup culture, blank wall above the kitchen. Codi found an artist and handled the whole project.',
    officePainting:
      'Pre-expansion paint job across two floors. Codi booked painters for the weekend and managed all building access.',
    glassFrosting:
      'Glass partition privacy upgrade. Codi measured, ordered, and installed frosted film in a single day.',
    officeSignage:
      'New brand identity needed new lobby signage. Codi designed, produced, and installed everything in under a week.',
    careRoom: 'Two parents on the team needed a designated space. Codi had the care room set up properly within days.',
    furnitureAssembly:
      'New office expansion with 25 workstations. Codi scheduled assembly crews and had everything ready before the team moved in.',
    layoutChange:
      'Hybrid work transition required a full reconfiguration. Codi reconfigured the floor over a long weekend.',
    officePlants:
      'Union Square office near the park. Codi brought in plants that complement the natural light and maintains them monthly.',
    keylessAccess:
      'Union Square startup, new office \u2014 keyless access from day one. Codi handled installation and manages all credentials.',
    alarmSystems:
      'Building required a monitored alarm before we could open. Codi coordinated the install and handles ongoing maintenance.',
    securityCameras:
      'Tech startup near Union Square \u2014 Codi installed security cameras at entry points and manages remote access.',
    keypads: 'Single main entry in our Union Square office. Codi installed the keypad and handles all code management.',
    lockboxes: 'Vendor access during off-hours. Codi manages the lockbox setup and ensures building compliance.',
    visitorManagement:
      'We get a steady flow of partner visits. Codi deployed a visitor check-in system that handles everything from arrival to logging.',
    businessInsurance:
      'Union Square building requires COI on file. Codi manages our policy and handles certificate requests on demand.',
    electricalServices:
      'Union Square startup needed additional circuits for growing infrastructure. Codi coordinated a licensed master electrician and managed all permit filing.',
    hvac: 'HVAC in our Union Square building required building engineering coordination for every service call. Codi manages all scheduling and vendor access.',
    plumbing:
      'Kitchen plumbing needed an upgrade for a coffee and water station. Codi coordinated the licensed plumber and building notification.',
    pestControl:
      'High-traffic Union Square location. Codi manages quarterly pest control and keeps compliance documentation on file for the building.',
    officeMoving:
      'Office expansion move in Union Square. Codi handled freight elevator scheduling, mover coordination, and the full setup on move day.',
    mountingInstallation:
      'Three conference rooms and a main display area. Codi mounted everything and ran clean cable management throughout.'
  },
  officeAssistant: {}
});
